// src/context/ProfileContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import API from "../config/config";

const ProfileContext = createContext();

export const useProfile = () => useContext(ProfileContext);

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [assignModule, setAssignModule] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const res = await fetch(API.ADMIN.GET_ADMIN_PROFILE, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.success) {
        setProfile(data.data);
        localStorage.setItem("adminRole", data.data.role?.slug);
        localStorage.setItem("adminProfile", JSON.stringify(data.data));
        if (data.data.employeeType === "new" && token) {
          try {
            const amRes = await fetch(API.ADMIN.ASSIGN_MODULE_ME, {
              headers: { Authorization: `Bearer ${token}` },
            });
            const amData = await amRes.json();
            if (amData.success && amData.data) setAssignModule(amData.data);
            else setAssignModule(null);
          } catch {
            setAssignModule(null);
          }
        } else {
          setAssignModule(null);
        }
      }
    } catch (err) {
      console.error("Error fetching admin profile:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <ProfileContext.Provider value={{ profile, setProfile, assignModule, setAssignModule, loading }}>
      {children}
    </ProfileContext.Provider>
  );
};
